/**
 * @module Experince/Product-Selector
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

/*tslint:disable max-file-line-count max-line-length */

import { ItemDetail } from '@support/api/common/product.interface';
import { CMMData, NewSimData } from '@experience/shop/byod/interfaces/byod-landing.interface';
import { CartService } from '@support/api/common/retrieveServices.interface';

export interface PlanModel {
  name: string;
  price: string;
  description: string;
}

export interface LineDetailsInfo {
  lineConfig: LineConfig[];
  unConfiguredLinesCount: number;
  tabletLines: number;
  voiceLines: number;
}

export interface LineConfig {
  isDeviceSelected: boolean;
  isPlanSelected: boolean;
  planType: string;
  deviceDescription: string;
  planDescriptions: string;
}

export interface ProductSelectorContentData {
  uiComponent: string;
  linesNeedADevice: string;
  linesNeedsAPlan: string;
  upscaleServiceMessage: string;
  serviceForEveryNeed: string;
  accessories: string;
  addADeviceAndPlan: string;
  addADevice: string;
  addALine: string;
  allModels: string;
  applyOffer: string;
  removeLineConfirmationMessage: string;
  saveCurrentSelectionToCartMessage: string;
  bringYourOwnDevice: string;
  cancel: string;
  certified: string;
  certifiedPreOwned: string;
  changeDevice: string;
  changePlan: string;
  choose: string;
  chooseADevice: string;
  color: string;
  continue: string;
  continueWithoutSaving: string;
  device: string;
  removeLineConfirmation: string;
  duplicateLine: string;
  duplicateThisLine: string;
  enterANameForLine: string;
  estimatedMonthly: string;
  existingLines: string;
  findRightPrepaidPlan: string;
  goToCart: string;
  learnMore: string;
  connectYourDeviceWithLine: string;
  line: string;
  lineNeedsADeviceSelection: string;
  lineNeedsAPlanSelection: string;
  memory: string;
  monthly: string;
  planNotRequiredMessage: string;
  notSelected: string;
  numberOfLines: string;
  offerCode: string;
  perMonthText: string;
  plan: string;
  plans: string;
  preOwned: string;
  pricingChangeMessage: string;
  recommended: string;
  removeThisLine: string;
  removed: string;
  saveAndAddLine: string;
  saveAndContinue: string;
  seeAllLineDetails: string;
  seeAllPlans: string;
  seeAllPrepaidPlans: string;
  seeAllServices: string;
  seeLess: string;
  seeMore: string;
  select: string;
  selectADevice: string;
  serviceOptions: string;
  services: string;
  shopForADevice: string;
  sku: string;
  summary: string;
  deviceCompatibiltyMessage: string;
  deviceCompatibiltyPlanServiceMessage: string;
  nonQualifyPriceAlert: string;
  dueTodayFund: string;
  today: string;
  scorePromotionMessage: string;
  maxLinesLimitMessages: string;
  yourCurrentSelections: string;
  afterYouRemoveThisLine: string;
  enterANicknameForLine: string;
  serviceNotAvailableMessage: string;
  youHaveLinesTotal: string;
  score: string;
  offersShownForZipCode: string;
  changeZipCodeMessage: string;
  ok: string;
  change: string;
  defaultZipCode: string;
  thirdPartyService: string;
  callTMobileCareToAddService: string;
  checkForThirdPartyBlocking: string;
  checkThirdPartyBlockingBeforeService: string;
  thirdPartyBlockingNotExisting: string;
  accountSettings: string;
  removeLinePriceChangeMessage: string;
  removeLine: string;
  removePackage: string;
  package: string;
  removePackageMessahe: string;
  removeThisPackage: string;
  seeOutsideThisPackage: string;
  removeBothPackages: string;
  removeItem: string;
  packageBreakMessage: string;
  startingAt: string;
  incompatibleServiceToPlanNotification: string;
  removePackageItemNotification: string;
  removePackages: string;
  areYouSureMessage: string;
  payInFull: string;
  addALineUpgradeMessage: string;
  removeThisLineUpgradeMessage: string;
  addLineUpgradeMessage: string;
  pricingDetails: string;
  originalPrice: string;
  finalPrice: string;
  includesLabel: string;
  free: string;
  selectFromServiceOptions: string;
  selectACategory: string;
  seeAllDevices: string;
  planDescription: string;
  deals: string;
  completePackageMessage: string;
  chooseAtleastOneAccessoryMessage: string;
  dealEnd: string;
  repInstructions: string;
  links: string;
  allOfferDetails: string;
  skuNumber: string;
  seeMoreDiscounts: string;
  seeAllPromotions: string;
  ratsHoldOnThere: string;
  transactionIncompleteNotification: string;
  outOfStock: string;
  limitedAvailability: string;
  someModelsOutOfStock: string;
  estimatedAvailabilityDates: string;
  retailPrice: string;
  pleaseSelectDevice: string;
  chooseAtleastOneService: string;
  preOrder: string;
  avoidLinesMessage: string;
  selectionMessage: string;
  prepaidPlans: string;
  promotionsAvailable: string;
  imeiLabel: string;
  remove: string;
  deviceLabel: string;
  checkNetworkCompatibility: string;
  verifyDeviceNetworkMessage: string;
  featured: string;
  checkDeviceCompatibility: string;
  passActivationMessage: string;
  sessionPassBeginMessage: string;
  qty: string;
  servicesPackages: string;
  deviceIncompatibleWithPlanMessage: string;
  noPlanChosenMessage: string;
  multipleSessionPassMessage: string;
  rebateLink: string;
  partialFailureModalDescription: string;
  activatingNewAccount: string;
  upgradeScreenError: string;
  addALineError: string;
  displayAllRequiredInformation: string;
  completeYourPurchase: string;
  expectedToShipDate: string;
  unavailableEstimatedDate: string;
  availableInStock: string;
  backordered: string;
  edit: string;
  simNumber: string;
  byodActivateGrabAndGo: string;
  requirementForDevicePricing: string;
  serviceToServiceConflictMessage: string;
  servicesConflictMightNotPerform: string;
  uhOhLabel: string;
  issueInCartWarningMessage: string;
  tryAgainLabel: string;
  selectPlanMessage: string;
  seeAll: string;
  nonQualifyingPlanMessage: string;
  qualifyingPlanMessage: string;
  lowerPriceMessage: string;
  congratulationMessage: string;
  nonQualifyingPlanDescription: string;
  pricingChangeWithoutServiceMessage: string;
  devicePricingUpdated: string;
  selectDeviceOrByod: string;
  thirdPartyServiceLabel: string;
  aServiceForEveryNeedLabel: string;
  zipCodeErrorMessage: string;
  choosePlanToEnableService: string;
  selectDevice: string;
  pleaseSelectADeviceToContinue: string;
  zipCodeText: string;
  zipCodeChangeSuccessful: string;
  zipCodeChangeSuccessfulFlag: string;
  enterZipCode: string;
  zipChangeAlert: string;
  changeValue: string;
  saveChange: string;
  seeAllCompatiblePlans: string;
  seeAllCompatibleDevices: string;
  currentLine?: string;
  remainingLinesMessage?: string;
  totalLines?: string;
  tablet?: string;
  voice?: string;
  uponActivation?: string;
  serviceOption?: string;
  removeLineMessage?: string;
}
export interface LineDeivceDetails {
  tileId?: string;
  lineId?: string;
  selectedMsisdn?: string;
  currentLineNumber?: number;
  lineTileType?: lineTypeEnum;
  isLineSetupCompleted?: boolean;
  disableIDontNeedCheckbox?: boolean;
  byodSimData?: NewSimData;
  byodCMMOrImei?: CMMOrImeiData;
  plansFromCart?: CartResponse;
  selectedPlanId?: string;
  noPlanNeeded?: boolean;
  lineStatus?: boolean;
  selectedDevice?: ItemDetail;
  // @TODO remove this interface
  deviceDetails?: ItemDetail; // only used in PDP page
  quantity?: number;
  isPlanSelected?: boolean;
  isExistingLine?: boolean;
  services?: Services;
  isByosFlow?: boolean;
  isUpgrade?: boolean;
  getUpdatedPlans?: boolean;
  isLineComplete?: boolean;
}
export interface CartResponse {
  nickName?: string; // Initially hard coding to Line 1.. to display in header. Replace with nick name
  planOfferName?: string;
  planDescription?: string;
  displayPrice?: number;
  salesPrice?: number;
  offerCode?: string;
  id?: string;
  familyCode?: string;
  cartItemId?: string;
}

export interface CMMOrImeiData {
  CMMData?: CMMData;
  imei?: string;
  isSkipSelected?: boolean;
  eid?: string;
}

export interface TileIdAndLengthToCreateLine {
  tileId?: string;
  currentLength?: number;
}
export enum lineTypeEnum {
  LINE,
  NONLINE,
  EXISTING,
  SCANTOCART,
}
export interface Services {
  servicesList?: string[];
  bundleId?: string;
  services?: CartService[];
}

export interface ExistingLineDetails {
  linesOccupied?: number;
  linesRemaining?: number;
  linesTotal?: number;
}
